import * as React from "react"
import { Box, Typography, CircularProgress } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { isAnalyzingAi, isOpenAiInsights, toggleAiInsights } from "@signals"
import { track } from "@analytics"


const TAB_WIDTH = 44
const TAB_EXPANDED_WIDTH = 164

export default function AiInsightsFloatingTab() {
	const [hovered, setHovered] = React.useState(false)
	const isOpen = isOpenAiInsights.value
	const isAnalyzing = isAnalyzingAi.value
	const expanded = hovered || isOpen

	// PUIG's name (`ia_insights_*`, a Spanish-ism) rather than this codebase's `ai`, so the same
	// query answers the question in both apps. Only the direction is recorded — never the drawer's
	// data or the question, which is user text.
	const handleClick = () => {
		track(isOpen ? 'ia_insights_closed' : 'ia_insights_opened')
		toggleAiInsights()
	}

	return (
		<Box
			onClick={handleClick}
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => setHovered(false)}
			sx={{
				position: 'fixed',
				right: 0,
				top: '50%',
				transform: 'translateY(-50%)',
				zIndex: 1200,
				display: 'flex',
				alignItems: 'center',
				height: 48,
				width: expanded ? TAB_EXPANDED_WIDTH : TAB_WIDTH,
				bgcolor: isOpen ? '#6941C6' : '#7F56D9',
				borderRadius: '24px 0 0 24px',
				cursor: 'pointer',
				boxShadow: '-2px 0px 10px rgba(127, 86, 217, 0.25)',
				transition: 'all 0.3s ease-in-out',
				overflow: 'hidden',
				'&:hover': {
					bgcolor: '#6941C6',
					boxShadow: '-3px 0px 14px rgba(127, 86, 217, 0.35)',
				},
			}}
		>
			{/* Icon container — fixed width, always centered */}
			<Box sx={{
				width: TAB_WIDTH,
				minWidth: TAB_WIDTH,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
			}}>
				{isAnalyzing
					? <CircularProgress size={18} sx={{ color: '#FFFFFF' }} />
					: <IconSeeker icon="wand-magic-sparkles" style={{ color: '#FFFFFF', fontSize: 17 }} />
				}
			</Box>

			{/* Label — fades in on expand */}
			<Typography
				variant="caption"
				sx={{
					color: '#FFFFFF',
					fontWeight: 600,
					whiteSpace: 'nowrap',
					opacity: expanded ? 1 : 0,
					transition: 'opacity 0.3s ease-in-out',
					fontSize: '0.8rem',
					letterSpacing: '0.02em',
					pr: 1.5,
				}}
			>
				AI Insights
			</Typography>
		</Box>
	)
}
